/**
 * Application route constants used throughout the app for navigation and routing.
 *
 * @constant {string} INDEX - The root path of the application.
 * @constant {string} ERROR - The wildcard route for handling 404 errors.
 * @constant {string} SESSION_EXPIRED - The route for session expiration page.
 * @constant {string} PROGRAMS - The route for the programs section.
 * @constant {string} TEMPLATES - The route for the templates section (with wildcard).
 * @constant {string} TEMPLATES_APP_PROCESS - The route for application process templates.
 * @constant {string} REVIEWS - The route for the reviews section.
 * @constant {string} INVITATIONS - The route for the invitations section.
 */

export const INDEX = `/`;
export const ERROR = `*`;
export const SESSION_EXPIRED = `/session-expired`;

// SubRoutes
export const PROGRAMS = '/programs';
export const TEMPLATES = '/templates/*';
export const TEMPLATES_APP_PROCESS = '/templates/applications';
export const REVIEWS = '/reviews';
export const INVITATIONS = '/invitations';
export const ORGANIZATION = '/organization';
